import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddMinimumPayPreferenceMutationVariables = Types.Exact<{
  salaryType: Types.JobSeekerProfileStructuredDataSalaryType;
  currency: Types.Scalars['String']['input'];
  amount: Types.Scalars['Float']['input'];
  sentiment: Types.JobSeekerProfileStructuredDataSentiment;
}>;


export type AddMinimumPayPreferenceMutation = { __typename?: 'Mutation', addJobSeekerProfileStructuredDataPreference?: { __typename?: 'AddJobSeekerProfileStructuredDataPreferencePayload', ignore: 'AddJobSeekerProfileStructuredDataPreferencePayload', preference?: { __typename?: 'JobSeekerProfileStructuredDataPreference', id?: string | null } | null } | null };


export const AddMinimumPayPreferenceDocument = gql`
    mutation AddMinimumPayPreference($salaryType: JobSeekerProfileStructuredDataSalaryType!, $currency: String!, $amount: Float!, $sentiment: JobSeekerProfileStructuredDataSentiment!) {
  addJobSeekerProfileStructuredDataPreference(
    input: {minimumPay: {salaryType: $salaryType, currency: $currency, amount: $amount, sentiment: $sentiment}}
  ) {
    ignore: __typename
    preference {
      id
    }
  }
}
    `;
export type AddMinimumPayPreferenceMutationFn = Apollo.MutationFunction<AddMinimumPayPreferenceMutation, AddMinimumPayPreferenceMutationVariables>;

/**
 * __useAddMinimumPayPreferenceMutation__
 *
 * To run a mutation, you first call `useAddMinimumPayPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMinimumPayPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMinimumPayPreferenceMutation, { data, loading, error }] = useAddMinimumPayPreferenceMutation({
 *   variables: {
 *      salaryType: // value for 'salaryType'
 *      currency: // value for 'currency'
 *      amount: // value for 'amount'
 *      sentiment: // value for 'sentiment'
 *   },
 * });
 */
export function useAddMinimumPayPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<AddMinimumPayPreferenceMutation, AddMinimumPayPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMinimumPayPreferenceMutation, AddMinimumPayPreferenceMutationVariables>(AddMinimumPayPreferenceDocument, options);
      }
export type AddMinimumPayPreferenceMutationHookResult = ReturnType<typeof useAddMinimumPayPreferenceMutation>;
export type AddMinimumPayPreferenceMutationResult = Apollo.MutationResult<AddMinimumPayPreferenceMutation>;
export type AddMinimumPayPreferenceMutationOptions = Apollo.BaseMutationOptions<AddMinimumPayPreferenceMutation, AddMinimumPayPreferenceMutationVariables>;